import { Form, Select, InputNumber, Button, message, Space, Alert } from 'antd';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { createCoupon } from '../../store/slices/couponSlice';
import { createPromotion } from '../../store/slices/promotionSlice';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

const days = [
    'Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'
];

const AddPromotion = () => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");

    const onSubmit = async (values) => {
        setLoading(true);
        setAlertMessage("");

        try {
            const result = await dispatch(createPromotion(values));

            if (createPromotion.fulfilled.match(result)) {
                navigate('/promotion');
            } else {
                setAlertMessage(result?.payload?.error || 'Error');
                setAlertType('error')
            }
        } catch (err) {
            setAlertMessage('Error creating coupon');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form form={form} onFinish={onSubmit} layout="vertical">
            {alertMessage && (
                <Alert
                    message={alertMessage}
                    type={alertType}
                    showIcon
                    icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                    closable
                    onClose={() => setAlertMessage('')}
                    style={{
                        marginBottom: 24,
                        borderRadius: '8px',
                    }}
                />
            )}
            <Form.Item name="day" label="Day" rules={[{ required: true }]}>
                <Select options={days.map(d => ({ label: d, value: d }))} />
            </Form.Item>

            <Form.Item name="discount_percent" label="Discount %" rules={[{ required: true }]}>
                <InputNumber min={1} max={100} style={{ width: '100%' }} />
            </Form.Item>

            <Form.Item>
                <Space>
                    <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    size="large"
                    block
                    style={{
                        height: '48px',
                        fontSize: '16px',
                        fontWeight: 600,
                        borderRadius: '8px',
                    }}
                    >
                        Submit
                    </Button>
                    <Button onClick={(e) => navigate(-1)}>Back</Button>
                </Space>
            </Form.Item>
        </Form>
    );
};

export default AddPromotion;